export default __webpack_public_path__ + "static/media/cam.9d717370.gif";